<template>
	<BaseCard
		:is-viewable="isUserAllowedInLevel3"
		:is-editable="isUserAllowedInLevel5or6"
		:title="$t('opo_list_repair_shop').toString()"
		@clickEdit="$router.push({ name: 'damagecases.payment', params: { id: $route.params.processId || $route.params.id, type: 'repairshop' } })"
		:is-toggle-open="isToggleOpen"
		:is-toggleable="true"
		@toggleCard="toggleCard($event)"
	>
		<template #icons v-if="isUserAllowedInLevel5or6 && showWarning">
			<div class="flex items-center">
				<font-awesome-icon icon="exclamation-triangle" class="text-red-700" />
			</div>
		</template>
		<div>
			<div class="font-bold" v-if="rechnungsbetrag == null">
				<div v-if="payment?.status">
					<BaseCardRow :label="$t('status')" :value="statusLabel" :class="{ 'text-red-600 font-bold': showWarning }"></BaseCardRow>
				</div>
				<div v-else>
					{{ $t('data_not_stored') }}
				</div>
			</div>
			<div v-else>
				<BaseCardRow :label="$t('billing_value')" :value="formatedMoney(rechnungsbetrag)"></BaseCardRow>
				<BaseCardRow :label="$t('open_amount')" :value="formatedMoney(damageCase.paymentRepairShopOffenerBetrag)"></BaseCardRow>
				<BaseCardRow :label="$t('status')" :value="statusLabel" :class="{ 'text-red-600 font-bold': showWarning }"></BaseCardRow>
			</div>
		</div>
	</BaseCard>
</template>
<script>
import BaseCard from '@/components/damagecases/forms/BaseCard';
import BaseCardRow from '@/components/damagecases/forms/BaseCardRow';
import Formatter from '@/mixins/Formatter';
import DunningStatus from '@/mixins/damagecase/DunningStatus';
import Authentication from '@/mixins/Authentication';

export default {
	name: 'OPORepairShopListCard',
	components: { BaseCard, BaseCardRow },
	mixins: [Formatter, DunningStatus, Authentication],
	props: {
		damageCase: {},
		isProcessFinished: {},
		isToggleOpen: { type: Boolean, default: true },
	},
	computed: {
		isEditAllowed() {
			return this.damageCase.offener_betrag !== 0 || !this.damageCase?.paymentRepairShop || this.rechnungsbetrag === null;
		},
		rechnungsbetrag() {
			return this.damageCase?.paymentRepairShop?.rechnungsbetrag;
		},
		payment() {
			return this.damageCase?.paymentRepairShop;
		},
	},
	methods: {
		toggleCard($event) {
			this.$emit('toggleCard', $event);
		},
		formatedMoney(money) {
			if (!money) {
				return '0,00 EUR';
			}
			return this.formatMoney(money);
		},
	},
};
</script>
